import { render, staticRenderFns } from "./InboxWindow.vue?vue&type=template&id=03ba6f90&scoped=true&"
import script from "./InboxWindow.vue?vue&type=script&lang=js&"
export * from "./InboxWindow.vue?vue&type=script&lang=js&"
import style0 from "./InboxWindow.vue?vue&type=style&index=0&id=03ba6f90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ba6f90",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Loading: require('/opt/build/repo/components/Loading.vue').default})
